import { render } from "./Detail.vue?vue&type=template&id=19a6a59c"
import script from "./Detail.vue?vue&type=script&lang=js"
export * from "./Detail.vue?vue&type=script&lang=js"

import "./Detail.vue?vue&type=style&index=0&id=19a6a59c&lang=css"

import exportComponent from "/var/www/bauminas/prod/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__